<template>
	<div id="app">
		<router-view />
	</div>
</template>
<script>
// 2026-08-24: 移除历史版本"悬浮课件/视频播放"功能整体残留(App.vue原全部内容:
// HoverList悬浮按钮/VabOnlyOffice面板/videoAndPpt课件讲解朗读/课程视频播放/基础水平选择弹窗,
// 及coursewareList+coursewarevideoList联动)——用户确认废弃, 组件文件与store状态一并清理
export default {
	name: 'App',
}
</script>
<style lang="scss" scoped>
#app {
	/* 全站唯一页面级滚动容器：html/body 已封死文档滚动（见 hud-theme.css 适配基线）。
	   祖先 overflow 不会困住 position:fixed（那需要 transform/filter 类属性），
	   长内容页（报告/图谱等）在 #app 内滚动，整页锁死页（答题页）自身 overflow:hidden。 */
	overflow-y: auto;
	overflow-x: hidden;
	height: 100%;
	overscroll-behavior: contain;
	position: relative;
}
</style>
